import type { Theme, SxProps } from "@mui/material/styles";

/**
 * Styles for Delays Report Filters component
 */
export const filtersStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  errorMessage: {
    color: theme.palette.error.main,
    fontSize: "0.75rem",
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
  },
});
